export const playerExtraInfoFragment = `
  fragment PlayerExtraInfoFragment on PlayerExtraInfo {
      favFoods
      favShows
      playlistLink
      fact
      favMemory
      gearHead
      gearMesh
      gearShaft
      gearCleats
      sponsors
      gearImage
}
  `

export const playerCurrentTeamFragment = `
  fragment PlayerCurrentTeamFragment on Team {
      officialId
      fullName
      position
      positionName
      jerseyNum
      injuryDescription
      injuryStatus
}
  `

export const playerFullStatsFragment = `
    fragment PlayerFullStatsFragment on PlayerStats {
        gamesPlayed
        goals
        assists
        points
        turnovers
        shots
        shotPct
        shotsOnGoal
        shotsOnGoalPct
        gamesStarted
        onePointGoals
        twoPointGoals
        twoPointShots
        twoPointShotPct
        saves
        savePct
        scoresAgainst
        goalsAgainst
        saa
        twoPointGoalsAgainst
        foRecord
        faceoffPct
        faceoffsWon
        causedTurnovers
        groundBalls
        powerPlayGoals
        powerPlayGoalsAgainst
        pimValue
        numPenalties
        touches
        totalPasses
}
  `
export const playerEventStatsFragment = `
  fragment PlayerEventStatsFragment on PlayerStats {
        gamesPlayed
        goals
        assists
        points
        turnovers
        shots
        shotPct
        shotsOnGoal
        shotsOnGoalPct
        gamesStarted
        onePointGoals
        twoPointGoals
        saves
        savePct
        scoresAgainst
        twoPointGoalsAgainst
        foRecord
        faceoffPct
        causedTurnovers
        groundBalls
        powerPlayGoals
        pimValue
        numPenalties
        touches
        totalPasses
}
  `

export const playerCareerStatsFragment = `
  fragment PlayerCareerStatsFragment on PlayerCareerStats {
        gamesPlayed
        goals
        assists
        points
        turnovers
        shots
        shotPct
        shotsOnGoal
        shotsOnGoalPct
        gamesStarted
        onePointGoals
        twoPointGoals
        saves
        savePct
        scoresAgainst
        foRecord
        faceoffPct
        causedTurnovers
        groundBalls
        powerPlayGoals
        pimValue
        numPenalties
        twoPointGoalsAgainst
}
  `